import { MarkdownText } from 'components/MarkdownText'
import { formatISODate } from 'utils/dates'
import { ChatMessage } from 'types/chat-message'
import { AttachmentMessage } from 'components/messages/AttachmentMessage'
import { useGetSetting } from 'api/settings'

export type UserTextMessageProps = {
  messageItem: ChatMessage
}
export const UserMessage = ({ messageItem }: UserTextMessageProps) => {
  const { message, createdAt } = messageItem
  const { setting } = useGetSetting()

  return (
    <div className={'tw-flex tw-flex-col tw-justify-end tw-gap-1'}>
      <div className="tw-flex tw-flex-row-reverse">
        <div className="tw-mt-4 tw-flex tw-max-w-[70%] tw-flex-col tw-items-end tw-justify-end ">
          <div
            className="tw-items-end tw-break-words tw-rounded-t-3xl tw-rounded-br-md tw-rounded-bl-3xl tw-bg-primary-500 tw-px-[10px] tw-py-[6px] tw-text-sm "
            style={{ color: 'white', backgroundColor: setting?.secondaryColor }}
          >
            <MarkdownText text={message} />
          </div>
        </div>
      </div>
      {messageItem.attachment?.map((att) => (
        <AttachmentMessage
          textClassName={'tw-text-white'}
          startsSequence={false}
          endsSequence={true}
          attachment={att}
          key={att._id}
          align={'right'}
          borderClass={'tw-rounded-t-3xl tw-rounded-br-md tw-rounded-bl-3xl tw-border-[0.5px]'}
        />
      ))}
      <div className="tw-flex tw-flex-row-reverse">
        <div className="tw-text-[10px] tw-italic tw-capitalize tw-text-white">{formatISODate(createdAt)}</div>
      </div>
    </div>
  )
}
